module.exports = __webpack_public_path__ + "img/terminal-square.1a745678.svg";